import api from '../api'

const state = {
  poiList: [],
  poiSelected: [],
  categoriesList: []
}

const getters = {
  getCurrentCategory: (state) => (id) => {
    return state.categoriesList.find(category => category.id === id)
  },
  getCategoryPOIs: (state) => (category) => {
    let id = parseInt(category)
    return state.poiList.filter(poi => poi.categories.some(category => category.id === id))
  },
  checkPOISelected: (state) => (poi) => {
    return state.poiSelected.find(p => p.id === poi.id) !== undefined
  }
}

const mutations = {
  setPOIs (state, poiList) {
    state.poiList = poiList
  },
  setCategories (state, categoriesList) {
    state.categoriesList = categoriesList
  },
  setSelectedPOIs (state, poiList) {
    state.poiSelected = poiList
  },
  addSelected (state, poi) {
    state.poiSelected.push(poi)
    sessionStorage.poiSelected = JSON.stringify(state.poiSelected)
  },
  removeSelected (state, poi) {
    let index = state.poiSelected.findIndex(p => p.id === poi.id)

    if (index !== -1) {
      state.poiSelected.splice(index, 1)
    }

    sessionStorage.poiSelected = JSON.stringify(state.poiSelected)
  }
}

const actions = {
  getPOIs ({ rootState, commit }, options) {
    return new Promise((resolve, reject) => {
      api.getPOIs(rootState.college.id, options).then(response => {
        commit('setPOIs', response.data)
        resolve(response.data)
      })
    })
  },
  getCategories ({ rootState, commit }) {
    api.getCategories(rootState.college.id).then(response => {
      commit('setCategories', response.data)
    })
  },
  selectPoi ({ getters, commit }, poi) {
    if (!getters.checkPOISelected(poi)) {
      commit('addSelected', poi)
    }
  },
  deselectPoi ({ commit }, poi) {
    commit('removeSelected', poi)
  },
  loadSelectedPoiList ({ commit }) {
    if (sessionStorage.poiSelected) {
      commit('setSelectedPOIs', JSON.parse(sessionStorage.poiSelected))
    }
  },
  getPersonalizedTourById ({ commit }, { student, tourId }) {
    api.getPersonalizedTourById(student, tourId).then((response) => {
      commit('setSelectedPOIs', response.data)
    })
  },
  savePersonalizedTour ({ commit }, { student, poiIds }) {
    return new Promise((resolve, reject) => {
      api.savePersonalizedTour(student, poiIds).then((response) => {
        resolve(response.data)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
